import { ReactNode, FC } from 'react';
import { IntercomProvider as ReactUseIntercomProvider } from 'react-use-intercom';

import Environment from '@/lib/environment';
import IntercomUpdater from './updater';

interface Props {
  children: ReactNode;
}

const { INTERCOM_APP_ID, INTERCOM_API_BASE } = Environment;

export const IntercomProvider: FC<Props> = ({ children }) => {
  return (
    <ReactUseIntercomProvider
      appId={INTERCOM_APP_ID}
      apiBase={INTERCOM_API_BASE}
      autoBoot
      autoBootProps={{
        hideDefaultLauncher: true,
        alignment: 'right',
        verticalPadding: 20,
      }}
    >
      <IntercomUpdater>{children}</IntercomUpdater>
    </ReactUseIntercomProvider>
  );
};
